import { Button, Card, CardContent, Grid, Typography, } from "@mui/material";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { nbfInvoice } from "../../../api/restApi";
import InvoiceModal from "../../../components/modals/InvoiceModal";
import NeworderModel from "../../../components/modals/NeworderModel";
import { customersData } from "../../../store/reducer/customersSlice";
import { discountPriceOnArrearsZero, generateBillForCustomer } from "../../../utils/helpers";
import { useAppSelector } from "../../../utils/hooks";
import { useSelector } from "react-redux";

const DeliveredOrder = ({ deliveredOrder, selectedDate }) => {
  const role = useSelector((state) => state.currentUser.role);
  const [orderCustomer, setOrderCustomer] = useState([]);
  const [openInvoice, setOpenInvoice] = useState(false);
  const [orderByCustomer, setOrderByCustomer] = useState("");
  const { customers } = useAppSelector(customersData);
  const [statusModifyOrder, setStatusModifyOrder] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [openProModal, setOpenProModal] = useState(false);
  const orderArrays = deliveredOrder?.map((element) => element);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [view,setView]= useState(false);
  const handleEditClick = async (row) => {
    if (row.status == undefined) {
      setStatusModifyOrder(false);
    } else setStatusModifyOrder(true);
    setSelectedRow(row);
    setOpenProModal(true);
    setSelectedRowId(row.id);
  };
  const handleClose = () => {
    setOpenProModal(false);
  };
  
  async function callData() {
    try {
      setOrderCustomer(
        orderArrays?.map((pro) => {
          return {
            ...pro.data.order,
            ...findCustomer(pro.customerId),
          };
        })
      );
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    if (deliveredOrder) {
      callData();
    }
  }, [deliveredOrder]);

  const findCustomer = (id) => {

  let discount = 0;
  if (!discountPriceOnArrearsZero){
    discount=0
  }
            //****************************/
    let cust = customers.find((el) => el.id?.toString() === id?.toString());
    let today = new Date();
    let date =
      today.getDate() +
      "-" +
      (today.getMonth() + 1) +
      "-" +
      today.getFullYear();
    return {
      ...cust,
      label: cust.name_urdu,
      date: date,
      selectedDate: selectedDate,
    };
  };
  const handleViewClick = async (row) => {
    let invoiceView = await nbfInvoice(selectedDate, row.id);
    console.log(invoiceView)
    let cust = await generateBillForCustomer({
      ...invoiceView,
      ...findCustomer(row.id),
    });

    setOrderByCustomer(cust);
    setOpenInvoice(true);
  };

  const handleView1 = async (row) => {
    let invoiceView = await nbfInvoice(selectedDate, row.id);
    if(!invoiceView.newOrder){
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'You Do Not Have Any New Order!',
      })
    }
    else{
      console.log(invoiceView)
      let cust = await generateBillForCustomer({
        ...invoiceView,
        ...findCustomer(row.id),
        view:1,
      });
  
      console.log(cust)
  
      setOrderByCustomer(cust);
      setOpenInvoice(true);
      
    }
  };

  return (
    <div>
    <Stack alignItems="center" spacing={1} marginTop="0rem">
    <Box sx={{ flexGrow: 0, padding: { xs: "1rem", md: "1rem" } }}>
      <Grid item xs={24} md={6}>
      <Card 
          alignItems='start'
                sx={{
                  width: "100%", 
                  marginTop: "0rem",
                  "@media (min-width: 300px)": {
                                width: 350, // Set the width to 100% for mobile view
                  },
                  "@media (min-width: 650px)": {
                                width: 650, // Set the width to 650px for screens wider than 650px
                  },
          }}
        >
    <CardContent>
        <Table
              marginRight="1rem"
              sx={{
                "@media (min-width: 315px)": {
                              width: 315, // Set the width to 100% for mobile view
                },
                "@media (min-width: 620px)": {
                              width: 620, // Set the width to 650px for screens wider than 650px
                },
        }}
            aria-label="simple table"
        >
            <TableHead style={{ backgroundColor: "#f5f5f5", height: "25px", align: 'start',width:'100%' }}>
              <TableRow sx={{ justifyContent:'start',width:'100%'}}>
              <TableCell>
                <Typography fontSize={"18px"} align="center">
                  ID
                </Typography>
              </TableCell>
              <TableCell>
                <Typography
                  align="center"
                  fontSize={"18px"}
                >
                  CUSTOMER  
                </Typography>
              </TableCell>
              <TableCell>
                <Typography align="center" fontSize={"18px"} >
                  ACTION
                </Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {orderCustomer &&
              orderCustomer.map((row, index) => {
                return (
                  <>
                    <TableRow
                      key={index}
                    >
                    <TableCell align="start" style={{ width:"0%", fontSize: 15,}}>
                        {row.id.length > 5 ? row.id.slice(0, 5) : row.id}
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{
                          fontSize: "17px",
                          paddingLeft: "10px",
                          wordWrap: 'break-word', maxWidth: '100px',
                          fontFamily: "NotoNastaliqUrdu",
                          width:"40%"
                        }}
                      >
                        {row.name_urdu}{" "}
                      </TableCell>
                      <TableCell
                      align="center"
                        style={{
                          height: "25px",
                          fontSize: "14px",
                          width:"40%",
                          justifyContent:"end"

                        }}
                      >
                        <Button
                              style={{justifyContent: 'center', width: '4rem',marginLeft:'1rem' }}
                              variant="outlined"
                          onClick={() => handleViewClick(row)}
                        >
                          view1
                        </Button>
                        {role!=="cs" &&(
                        <Button  
                            style={{justifyContent: 'center', width: '4rem',marginLeft:'1rem' }}
                            variant="outlined"
                            onClick={() => handleEditClick(row)}
                          >
                            Order2
                          </Button>
                          )}
                          {role!=="cs" &&(
                          <Button
                              style={{justifyContent: 'center', width: '4rem',marginLeft:'1rem' }}
                              variant="outlined"
                              onClick={()=>handleView1(row)}>
                            View2
                          </Button>
                          )}
                      </TableCell>
                    </TableRow>
                  </>
                );
              })}
          </TableBody>
        </Table>
        </CardContent>
        </Card>
      </Grid>
      </Box>
      </Stack>
      {orderByCustomer && (
        <InvoiceModal
          openInvoice={openInvoice}
          orderByCustomer={orderByCustomer}
          setOpenInvoice={setOpenInvoice}
        />
      )}
      <NeworderModel
        detailOpen={openProModal}
        handleClose={handleClose}
        customerId={selectedRowId}
        selectedRow={selectedRow}
        date={selectedDate}
        view={view}
      />
    </div>
  );
};

export default DeliveredOrder;
